import React, { useState, useEffect } from "react";

// Icons
import {
  AiFillEye,
} from "react-icons/ai";

import { toDateTime } from "../../../Services/string.service";

// Props Values
/* 
  data: [],  
  columns: ['Id', 'Name'],
  fields: ['id', 'name'],
  onView : function
*/

const LongTable = (props) => {
  const [registers, setRegisters] = useState([]);

  const onView = (item) => props.onView(item);

  const buttons = (item) => {
    return (
      <>
        <div className='row'>
          <div className='col-6'>
            <AiFillEye className='icon-button' onClick={() => onView(item)} />
          </div>
        </div>
      </>
    );
  };

  const renderField = (value) => {
    if (typeof value === 'number') {
      return value; 
    }
    
    if (isValidDate(value))
      return toDateTime(value)
    else
      return value;
  };

    function isValidDate(dateString) {
      if (typeof dateString === 'number') {
        return true; // Se for um número, considera válido (não precisa converter)
      }
      const date = new Date(dateString);
      return !isNaN(date.getTime());
    }

  useEffect(() => {
    setRegisters(props.data);
  }, [props])


  return (
    <>

      <div className='table-responsive text-nowrap'>
        <table className='table' id='paginated-table'>
          <thead>
            <tr>
              {props.columns &&
                props.columns.map((column, index) => (
                  <th key={index}>{column}</th>
                ))}
              <th>Ações</th>
            </tr>
          </thead>
          <tbody className='table-border-bottom-0'>
            {registers?.length > 0 ?
              registers.map((item, index) => (
                <>
                  <tr key={index}>
                    {props.fields.map((fields, fieldsIndex) => (
                      <td key={fieldsIndex}>{renderField(item[fields])}</td>
                    ))}

                    <td className='action-table-col'>
                      {buttons(item)}
                    </td>
                  </tr>

                </>)) : ""}
          </tbody>
        </table>
      </div>
    </>
  );
};
export default LongTable;
